const Acl = {
    namespaced: true,
    state: {
        disabledEntityFields: [],
    },
    mutations: {
        SET_DISABLED_ENTITY_FIELDS(state, { entity, disabled_fields }) {
            state.disabledEntityFields[entity] = disabled_fields || [];
        },
    },
    getters: {
        isDisabledEntityField: (state) => (fieldName) => {
            let entity = fieldName.split('.')[0];
            let field = fieldName.split('.')[1];

            let disabledFields = state.disabledEntityFields[entity] || [];

            if (disabledFields.includes(field)) {
                return true;
            }

            //field without id
            if (disabledFields.includes(field.replace(/_id$/, ''))) {
                return true;
            }

            return false;
        },
    },
    actions: {
        loadDisabledEntityFields({ commit }, { entity, disabled_fields }) {
            commit('SET_DISABLED_ENTITY_FIELDS', { entity, disabled_fields });
        },
    },
};

export default Acl;
